/* Tiroir de panier GLAMES.
   Le theme clone n'en avait pas : le formulaire postait vers /cart et
   rechargeait la page. On intercepte, on ajoute en AJAX, on ouvre le tiroir. */
(function () {
  var SEUIL_PORT = 4500;
  var RESERVE = 4 * 60;           // duree du panier reserve, en secondes

  var tiroir, minuteurId = null;
  /* Adresse de départ dans la langue de la page : « / » en français, « /it/ » en italien, « /es/ » en espagnol.
     Sans elle, le panier d'une page traduite répondait en français (12/10/2026). */
  var RACINE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  /* Textes réglés dans Paramètres du thème → COVALIE · Panier, posés sur #hy-tiroir (data-mot-…). */
  function mot(cle, defaut) {
    var v = tiroir && tiroir.getAttribute('data-mot-' + cle);
    return v === null || v === undefined ? defaut : v;
  }
  var barres = {};                // handle -> { id de variante : prix barre }

  function chargerBarres(panier) {
    var aFaire = panier.items
      .map(function (a) { return a.handle; })
      .filter(function (h, i, t) { return h && t.indexOf(h) === i && !barres[h]; });
    if (!aFaire.length) return Promise.resolve();
    return Promise.all(aFaire.map(function (h) {
      return fetch(RACINE + 'products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          barres[h] = {};
          p.variants.forEach(function (v) { if (v.compare_at_price) barres[h][v.id] = v.compare_at_price; });
        }).catch(function () {});
    }));
  }
  var q = function (s, r) { return (r || document).querySelector(s); };
  var qq = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  /* Prix dans la devise du client : « 39,99 € » en euro comme toujours, sinon le format de la devise (« CHF 39.00 »). */
  var deviseClient = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var euro = function (c) {
    if (deviseClient === 'EUR') return (c / 100).toFixed(2).replace('.', ',') + ' €';
    try { return new Intl.NumberFormat('fr-CH', { style: 'currency', currency: deviseClient }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2) + ' ' + deviseClient; }
  };
  var texte = function (s) {
    var d = document.createElement('div'); d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  };
  var deshtml = function (s) {
    var d = document.createElement('textarea'); d.innerHTML = s || ''; return d.value;
  };

  /* ---------- rendu ---------- */

  var cacheDispo = {};
  // Retire du panier les articles devenus indisponibles, avant que le client n'arrive au paiement.
  function nettoyerIndisponibles(panier) {
    var aVerifier = (panier.items || []).filter(function (a) { return a.handle; });
    if (!aVerifier.length) return Promise.resolve(panier);
    return Promise.all(aVerifier.map(function (a) {
      if (cacheDispo[a.handle] !== undefined) return Promise.resolve({ a: a, p: cacheDispo[a.handle] });
      return fetch(RACINE + 'products/' + a.handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { cacheDispo[a.handle] = p; return { a: a, p: p }; })
        .catch(function () { return { a: a, p: null }; });
    })).then(function (res) {
      var aRetirer = res.filter(function (x) {
        if (!x.p) return false;
        var v = (x.p.variants || []).filter(function (vv) { return vv.id === x.a.variant_id; })[0];
        return v && v.available === false;
      });
      if (!aRetirer.length) return panier;
      return aRetirer.reduce(function (chaine, x) {
        return chaine.then(function () {
          return fetch(RACINE + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: String(x.a.key), quantity: 0 })
          }).then(function (r) { return r.json(); });
        });
      }, Promise.resolve()).then(function (dernier) { return dernier || panier; });
    });
  }

  function rendre(panier) {
    if (!tiroir) return;
    var vide = panier.item_count === 0;
    q('[data-hy-nb]', tiroir).textContent =
      panier.item_count + ' ' + (panier.item_count > 1 ? mot('articles', 'articles') : mot('article', 'article'));
    q('[data-hy-vide]', tiroir).hidden = !vide;
    q('[data-hy-pied]', tiroir).hidden = vide;
    q('[data-hy-minuteur]', tiroir).hidden = vide;
    q('[data-hy-port]', tiroir).style.display = vide ? 'none' : '';

    var liste = q('[data-hy-lignes]', tiroir);
    liste.innerHTML = panier.items.map(function (a, i) {
      /* la taille n'est plus une variante (produit en taille unique) : elle arrive en note de
         ligne. On l'affiche à la suite de la couleur, pour que le panier soit lu comme avant. */
      var opts = (a.options_with_values || [])
        .filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return texte(o.name) + ' : ' + texte(o.value); })
        .concat(Object.keys(a.properties || {})
          .filter(function (k) { return k.charAt(0) !== '_' && a.properties[k]; })
          .map(function (k) { return texte(k) + ' : ' + texte(a.properties[k]); }))
        .join(' · ');
      /* Prix barré = l'ancien prix (« comparé à » × quantité), comme sur la fiche : barré − payé = les économies du bas. */
      var refLigne = barres[a.handle] && barres[a.handle][a.variant_id];
      var barreMontant = (refLigne && a.final_line_price >= a.original_line_price)
        ? Math.max(a.original_line_price, refLigne * a.quantity) : a.original_line_price;
      var barre = barreMontant > a.final_line_price
        ? '<s>' + euro(barreMontant) + '</s>' : '';
      return '<li class="hy-ligne" data-cle="' + texte(a.key) + '" data-rang="' + (i + 1) + '">' +
        (a.image ? '<img class="hy-ligne__img" src="' + texte(a.image + (a.image.indexOf('?') > -1 ? '&' : '?') + 'width=220') + '" alt="" width="75" height="75" loading="lazy">' : '<span class="hy-ligne__img"></span>') +
        '<div><a class="hy-ligne__titre" href="' + texte(a.url) + '">' + texte(deshtml(a.product_title)) + '</a>' +
        (opts ? '<p class="hy-ligne__opt">' + opts + '</p>' : '') +
        (a.final_line_price === 0 ? '<div class="hy-ligne__bas"><span class="hy-ligne__cadeau">' + texte(mot('cadeau', '🎁 Cadeau offert')) + '</span><span class="hy-ligne__prix">' + euro(0) + '</span></div></div></li>' : '') +
        (a.final_line_price === 0 ? '' : '<div class="hy-ligne__bas"><span class="hy-qte">' +
          '<button type="button" data-hy-moins aria-label="Diminuer la quantité">−</button>' +
          '<span>' + a.quantity + '</span>' +
          '<button type="button" data-hy-plus aria-label="Augmenter la quantité">+</button>' +
        '</span><span class="hy-ligne__prix">' + barre + euro(a.final_line_price) + '</span></div>' +
        '<button type="button" class="hy-ligne__retirer" data-hy-retirer>' + texte(mot('retirer', 'Retirer')) + '</button></div></li>');
    }).join('');

    var eco = panier.original_total_price - panier.total_price;
    // les prix barres ne sont pas dans /cart.js : on les lit sur les produits
    panier.items.forEach(function (a) {
      var ref = barres[a.handle] && barres[a.handle][a.variant_id];
      // prix « comparé à » seulement pour un article sans remise de lot (ensemble seul : 49,99 → 39,99) ;
      // dès qu'un lot s'applique, l'économie se calcule sur le vrai prix, comme sur la fiche.
      if (ref && ref > a.price && a.final_line_price >= a.original_line_price) eco += (ref - a.price) * a.quantity;
    });
    var blocEco = q('[data-hy-economie]', tiroir);
    blocEco.style.display = eco > 0 ? 'flex' : 'none';
    if (eco > 0) q('[data-hy-economie-val]', tiroir).textContent = '− ' + euro(eco);
    q('[data-hy-total]', tiroir).textContent = euro(panier.total_price);

    // seuil de livraison offerte converti dans la devise du client
    var seuil = deviseClient === 'EUR' ? SEUIL_PORT : Math.round(SEUIL_PORT * (parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1));
    var manque = seuil - panier.total_price;
    var t = q('[data-hy-port-texte]', tiroir);
    if (manque > 0) {
      t.innerHTML = texte(mot('manque', 'Plus que [montant] pour la livraison offerte')).replace('[montant]', '<b>' + euro(manque) + '</b>');
      q('[data-hy-jauge]', tiroir).style.width =
        Math.max(4, Math.round(panier.total_price / seuil * 100)) + '%';
    } else {
      t.innerHTML = '<b>' + texte(mot('gagne', 'Bravo, la livraison est offerte !')) + '</b>';
      q('[data-hy-jauge]', tiroir).style.width = '100%';
    }

    var sup = q('[data-hy-sup]', tiroir);
    if (sup) {
      var dedans = panier.items.some(function (a) { return String(a.variant_id) === sup.dataset.id; });
      q('.hy-bascule', sup).setAttribute('aria-checked', dedans ? 'true' : 'false');
    }
    qq('[data-hy-bulle]').forEach(function (b) { b.textContent = panier.item_count; });
    // annonce le panier affiché aux autres scripts (cz-offert-auto.js : 3e ensemble offert)
    try { document.dispatchEvent(new CustomEvent('hy:panier', { detail: panier })); } catch (e) {}
  }

  /* Seule la lecture la plus récente du panier s'affiche : une réponse plus ancienne qui arriverait en retard
     n'écrase plus le panier à jour (05/10/2026). */
  var tourRafraichir = 0;
  function rafraichir() {
    var tour = ++tourRafraichir;
    return fetch(RACINE + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { return chargerBarres(p).then(function () { if (tour === tourRafraichir) rendre(p); return p; }); });
  }

  /* ---------- ouverture / fermeture ---------- */

  function ouvrir(sansRelire) {
    if (!tiroir) return;
    if (sansRelire !== true) rafraichir();          // le panier a pu changer depuis le chargement de la page
    tiroir.hidden = false;
    tiroir.setAttribute('aria-hidden', 'false');
    // requestAnimationFrame ne se declenche pas dans un onglet masque :
    // on garde un repli sur setTimeout pour que l'ouverture aboutisse toujours.
    var montrer = function () { tiroir.classList.add('est-ouvert'); };
    requestAnimationFrame(montrer);
    setTimeout(montrer, 30);
    var y = window.scrollY || 0; document.documentElement.style.setProperty('--hy-defil', (-y) + 'px'); document.documentElement.classList.add('hy-tiroir-ouvert'); document.body.classList.add('hy-tiroir-ouvert'); document.body.dataset.hyDefil = String(y);
    lancerMinuteur();
  }
  /* Ajout au panier (05/10/2026) : le tiroir s'ouvre dès le clic, en « ajout en cours », puis se remplit quand
     Shopify répond. Avant, il attendait l'ajout, la lecture du panier et celle des prix barrés (≈ 1 s sur 4G). */
  var minuteurAjout = null;
  function ouvrirEnAjout() {
    if (!tiroir) return;
    tiroir.classList.add('hy-tiroir--ajout');
    clearTimeout(minuteurAjout);
    minuteurAjout = setTimeout(finAjout, 8000);   // jamais bloqué en « ajout en cours », même sans réponse
    ouvrir(true);
  }
  function finAjout() {
    clearTimeout(minuteurAjout);
    if (tiroir) tiroir.classList.remove('hy-tiroir--ajout');
  }

  function fermer() {
    if (!tiroir) return;
    tiroir.classList.remove('est-ouvert');
    tiroir.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('hy-tiroir-ouvert'); document.body.classList.remove('hy-tiroir-ouvert'); window.scrollTo(0, parseInt(document.body.dataset.hyDefil || '0', 10));
    setTimeout(function () { if (!tiroir.classList.contains('est-ouvert')) tiroir.hidden = true; }, 320);
  }

  function lancerMinuteur() {
    var champ = q('[data-hy-chrono]', tiroir);
    if (!champ || minuteurId) return;
    var fin;
    try { fin = parseInt(sessionStorage.getItem('hy-reserve'), 10) || 0; } catch (e) { fin = 0; }
    var maintenant = Math.floor(performance.timeOrigin ? (performance.timeOrigin + performance.now()) / 1000 : 0);
    if (!fin || fin <= maintenant) {
      fin = maintenant + RESERVE;
      try { sessionStorage.setItem('hy-reserve', String(fin)); } catch (e) {}
    }
    // affiché tout de suite (sinon le texte fixe du tiroir, « 04:00 », reste une seconde avant le vrai temps)
    var afficher = function () {
      var t = Math.floor(performance.timeOrigin ? (performance.timeOrigin + performance.now()) / 1000 : 0);
      var reste = Math.max(0, fin - t);
      champ.textContent = String(Math.floor(reste / 60)).padStart(2, '0') + ':' + String(reste % 60).padStart(2, '0');
      if (reste === 0 && minuteurId) { clearInterval(minuteurId); minuteurId = null; }
      return reste;
    };
    if (afficher() === 0) return;
    minuteurId = setInterval(afficher, 1000);
  }

  /* ---------- actions ---------- */

  function changer(rang, qte) {
    return fetch(RACINE + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(rang), quantity: qte })
    }).then(function (r) { return r.json(); })
      .then(function (p) { return nettoyerIndisponibles(p).then(function (p2) { chargerBarres(p2).then(function () { rendre(p2); }); }); });
  }

  function ajouter(id, qte, formulaire) {
    var req = formulaire
      ? { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(formulaire) }   // le formulaire entier : offres groupees, proprietes
      : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qte || 1 }] }) };
    return fetch(RACINE + 'cart/add.js', req).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message); });
      return r.json();
    }).then(function () { return rafraichir(); });
  }

  function brancher() {
    tiroir = q('#hy-tiroir');
    if (!tiroir) return;
    // seuil de livraison offerte (en centimes d'euro, converti plus bas dans la devise du client) et durée du minuteur : réglages du thème
    var seuilRegle = parseInt(tiroir.getAttribute('data-seuil'), 10);
    if (!isNaN(seuilRegle)) SEUIL_PORT = seuilRegle;
    RESERVE = (parseInt(tiroir.getAttribute('data-reserve'), 10) || 4) * 60;

    qq('[data-hy-fermer]', tiroir).forEach(function (b) { b.addEventListener('click', fermer); });
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && tiroir.classList.contains('est-ouvert')) fermer();
    });

    tiroir.addEventListener('click', function (e) {
      var ligne = e.target.closest('.hy-ligne');
      if (ligne) {
        var rang = ligne.dataset.rang;
        var qte = parseInt(q('.hy-qte span', ligne).textContent, 10) || 1;
        if (e.target.closest('[data-hy-plus]')) return changer(rang, qte + 1);
        if (e.target.closest('[data-hy-moins]')) return changer(rang, Math.max(0, qte - 1));
        if (e.target.closest('[data-hy-retirer]')) return changer(rang, 0);
      }
      var bascule = e.target.closest('.hy-bascule');
      if (bascule) {
        var sup = bascule.closest('[data-hy-sup]');
        var actif = bascule.getAttribute('aria-checked') === 'true';
        bascule.setAttribute('aria-checked', actif ? 'false' : 'true');
        if (actif) {
          return fetch(RACINE + 'cart.js').then(function (r) { return r.json(); }).then(function (p) {
            var i = p.items.findIndex(function (a) { return String(a.variant_id) === sup.dataset.id; });
            return i >= 0 ? changer(String(i + 1), 0) : rafraichir();
          });
        }
        return ajouter(sup.dataset.id, 1).then(ouvrir);
      }
    });

    // le bouton d'ajout ouvre le tiroir au lieu de recharger la page
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || f.tagName !== 'FORM') return;
      var action = f.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      var champ = f.querySelector('[name="id"]');
      if (!champ || !champ.value) return;
      e.preventDefault(); e.stopPropagation();
      var bouton = f.querySelector('button[name="add"], .product-form__submit');
      if (bouton) bouton.classList.add('hy-charge');
      var qte = parseInt((f.querySelector('[name="quantity"]') || {}).value, 10) || 1;
      ajouter(champ.value, qte, f)
        .then(ouvrir)
        .catch(function (err) {
          console.error(err);
          f.submit();   // repli : on laisse le navigateur poster le formulaire
        })
        .then(function () { if (bouton) bouton.classList.remove('hy-charge'); });
    }, true);

    // l'icone panier de l'entete ouvre le tiroir
    qq('a[href]').filter(function (a) {
      var h = a.getAttribute('href') || '';
      return /^(https?:\/\/[^\/]+)?\/cart\/?($|\?)/.test(h);
    }).forEach(function (a) {
      if (a.closest('#hy-tiroir')) return;
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault(); e.stopPropagation(); ouvrir();
      }, true);
    });
    qq('#cart-icon-bubble, .header__icon--cart, [data-cart-icon]').forEach(function (b) {
      if (b.tagName === 'A') return;
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); ouvrir(); }, true);
    });

    // Les scripts du theme (offre groupee, ajout rapide) ouvrent le tiroir Dawn sans passer par un submit :
    // quand ce tiroir-la veut s'ouvrir, c'est le notre qui s'ouvre.
    var dawn = document.querySelector('cart-drawer');
    if (dawn && window.MutationObserver) {
      new MutationObserver(function () {
        if (dawn.classList.contains('active') || dawn.classList.contains('is-open')) {
          dawn.classList.remove('active'); dawn.classList.remove('is-open');
          rafraichir().then(ouvrir);
        }
      }).observe(dawn, { attributes: true, attributeFilter: ['class'] });
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.pob-atc--enhanced')) setTimeout(function () { rafraichir().then(ouvrir); }, 1800);
    }, true);
    rafraichir();
    // Fiche produit : ses prix barrés sont lus dès le chargement, l'ajout au panier n'a plus à les attendre (05/10/2026).
    var fiche = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (fiche) chargerBarres({ items: [{ handle: decodeURIComponent(fiche[1]) }] });
    window.hyTiroirPanier = { ouvrir: ouvrir, fermer: fermer, rafraichir: rafraichir, ouvrirEnAjout: ouvrirEnAjout, finAjout: finAjout };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancher);
  else brancher();
})();
